import React from "react";
import PropTypes from "prop-types";

const Icon = ({
  className,
  name,
  size,
  color
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  fill: color,
  height: size,
  width: size
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: `#${name}`
}));

if (process.env.NODE_ENV !== "production") {
  Icon.displayName = "Icon";
}

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number
};
Icon.defaultProps = {
  color: "#000000",
  size: 24
};
export default Icon;